const Config = {
  env: process.env.REACT_APP_ENV || 'development',
  hosts: {
    apiHost: process.env.REACT_APP_BACKEND_API_HOST,
  },
};

export { Config };
